import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import Utils from "../../utils/Utils";

export const ModelSandbox = ({ show = true }) => {
  const router = useRouter();
  return (
    <div className="container stats-explained">
      <div className="text-left">
        <h2>Model Sandbox</h2>
        <h5>How exactly does the Model Sandbox tool work?</h5>
      </div>
      <div className="text-left" style={{ display: "flex", flexDirection: "column" }}>
        <p>
          <b style={{ color: "#d07c3b" }}>Model Sandbox</b> creates custom betting models based on the parameters
          chosen. The system uses the parameters entered to find the most predictive weighting and fits them to past
          scores to create the most accurate predictions possible for the inputs given. This custom weighting is applied
          forward and instantly graded based on a selected Points-of-Value threshold.
        </p>

        <Image
          src={Utils.getAsset("ModelSandboxToolPreview.png")}
          alt="picture showing how the model sandbox tool works"
          className="rounded"
        />

        <a
          href={`/model-sandbox`}
          target={"_blank"}
          style={{
            padding: "15px 50px",
            width: "200px",
            alignSelf: "center",
            marginTop: "15px",
          }}
          className="btn btn-orange"
        >
          Go to the Tool
        </a>
      </div>
    </div>
  );
};
